import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { IlIcon } from '../IlIcon/index.js';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

function IlDataTableV3ColumnManager(props) {
  function setColumnSetting(field, property, value) {
    var columns = props.columns.map(function (c) {
      return c;
    });
    columns.forEach(function (column) {
      if (column.field === field) {
        column[property] = value;
      }
    });
    props.setColumns(columns);
  }
  function renderColumnList() {
    var renderedColumns = [];
    props.columns.forEach(function (column, i) {
      if (!column.field) {
        return;
      }
      var checkBoxClassName = 'unchecked';
      if (!column.hide) {
        checkBoxClassName = 'checked';
      }
      if (!column.hide && column.disabled) {
        checkBoxClassName = 'checkboxDisabled';
      }
      renderedColumns.push(/*#__PURE__*/React__default.createElement(Draggable, {
        key: column.field,
        draggableId: column.field,
        index: i
      }, function (provided, snapshot) {
        return /*#__PURE__*/React__default.createElement("div", _extends({
          className: 'IlDataTableV3ColumnManager-Column',
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps), /*#__PURE__*/React__default.createElement("div", {
          className: 'IlDataTableV3ColumnManager-Column-ReorderButton'
        }, /*#__PURE__*/React__default.createElement(IlIcon, {
          name: 'gs-reorderrow'
        })), /*#__PURE__*/React__default.createElement("div", {
          className: 'IlDataTableV3ColumnManager-Column-HideButton',
          onClick: function onClick() {
            if (column.disabled) return;
            setColumnSetting(column.field, 'hide', !column.hide);
          }
        }, /*#__PURE__*/React__default.createElement("input", {
          type: 'checkbox',
          disabled: column.disabled,
          checked: !column.hide
        }), /*#__PURE__*/React__default.createElement("div", {
          className: checkBoxClassName,
          onClick: function onClick() {
            if (column.disabled) return;
            setColumnSetting(column.field, 'hide', !column.hide);
          }
        }, !!column.hide ? null : /*#__PURE__*/React__default.createElement(IlIcon, {
          name: 'gs-check'
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: "IlDataTableV3ColumnManager-Column-Title ".concat(column.disabled ? 'IlDataTableV3ColumnManager-Column-Title-Disabled' : '')
        }, column.headerName || column.field), /*#__PURE__*/React__default.createElement("div", {
          className: 'IlDataTableV3ColumnManager-Column-PinButton',
          onClick: function onClick() {
            setColumnSetting(column.field, 'pinned', !!column.pinned ? false : 'left');
          }
        }, !!column.pinned ? /*#__PURE__*/React__default.createElement(IlIcon, {
          name: 'gs-pinned'
        }) : /*#__PURE__*/React__default.createElement(IlIcon, {
          name: 'gs-pin'
        })));
      }));
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'IlDataTableV3ColumnManager-ColumnList'
    }, /*#__PURE__*/React__default.createElement(Droppable, {
      droppableId: 'droppable'
    }, function (provided, snapshot) {
      return /*#__PURE__*/React__default.createElement("div", _extends({}, provided.droppableProps, {
        ref: provided.innerRef
      }), renderedColumns, provided.placeholder);
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'IlDataTableV3ColumnManager'
  }, /*#__PURE__*/React__default.createElement(DragDropContext, {
    nonce: props.nonceId,
    onDragEnd: function onDragEnd(result) {
      var _final = Array.from(props.columns);
      var _final$splice = _final.splice(result.source.index, 1),
        _final$splice2 = _slicedToArray(_final$splice, 1),
        removed = _final$splice2[0];
      _final.splice(result.destination.index, 0, removed);
      props.setColumns(_final);
    }
  }, renderColumnList()));
}

export { IlDataTableV3ColumnManager };
